/**
 * Qual versão deste aplicativo está rodando neste aparelho.
 *
 * São três coisas diferentes, e elas respondem a perguntas diferentes:
 *
 * - `VERSAO_APP` ("1.0.0") é o que vai para a API em toda chamada (`v=1.0.0`).
 *   Veio do TMobi e é contrato com o backend — não muda porque a tela mudou.
 * - `VERSAO_NA_TELA` é a data da subida (`V 2.6.09.24`), carimbada pelo Vite.
 *   É o que o operador lê para o suporte no telefone, e é a que responde "de
 *   quando é o que está aí?" sem ninguém precisar decorar número de versão.
 * - A compilação é o commit que gerou este build. Não aparece na tela — fica
 *   no log do navegador, para quando a data não bastar e for preciso saber
 *   exatamente que código está servindo. Num PWA isso importa: o service
 *   worker pode estar entregando uma versão guardada dias atrás.
 *
 * O `+` no fim do commit significa build feito com alteração não commitada:
 * sai do `npm run dev` e do build local de quem está mexendo no código.
 */

import {VERSAO_APP} from '../api/cliente';

declare const __COMPILACAO__: string;
declare const __VERSAO_TELA__: string;

export const COMPILACAO =
  typeof __COMPILACAO__ === 'string' && __COMPILACAO__ ? __COMPILACAO__ : 'dev';

/**
 * O que aparece na tela. Fora do build — num teste, num ambiente que não
 * passou pelo Vite — cai no número do protocolo, que sempre existe.
 */
export const VERSAO_NA_TELA =
  typeof __VERSAO_TELA__ === 'string' && __VERSAO_TELA__ ? __VERSAO_TELA__ : VERSAO_APP;

console.log(`[versao] ${VERSAO_NA_TELA} · api ${VERSAO_APP} · compilação ${COMPILACAO}`);
